(ns frontend.ui.component.lp-portal.card.pdf.view
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color]]
   [clojure.string :as string]))

(defn- card-raw
  [title unbreakable? & children]
  (let [title-definition (when-not (nil? title)
                           {:text   (string/upper-case (str title))
                            :bold   true
                            :margin [0 15 0 10]
                            :color  (theme/color [:pdf :heading])})]
    (merge {:stack (->> children
                        (cons title-definition)
                        (remove nil?)
                        (vec))}
           (when unbreakable?
             {:unbreakable true}))))

(defn card-no-breaks-must-fit-on-1-page
  [title & children]
  (apply card-raw (concat [title true] children)))

(defn card
  [title & children]
  (apply card-raw (concat [title false] children)))
